<script setup lang="ts">
/**
 * Authenticated layout — header (with BCU, model selector, user menu) + main content, no footer.
 */
import AppHeader from './components/AppHeader.vue'
</script>

<template>
  <div class="min-h-screen flex flex-col">
    <AppHeader>
      <template #center>
        <slot name="header-center" />
      </template>
    </AppHeader>
    <main class="flex-1 flex flex-col">
      <slot />
    </main>
  </div>
</template>
